import { ArrowLeft, Download, Monitor, Music2, Package, Radio, ShieldCheck } from "lucide-react";

const macDownloadHref = "/downloads/live-visualizer-macos-0.1.1.zip";
const macDownloadLabel = "0.1.1 ad-hoc signed preview, 4.1 MB";

const capabilities = [
  { icon: Radio, label: "Live input", value: "Mic, line-in, or loopback bus" },
  { icon: Monitor, label: "Stage output", value: "Fullscreen macOS renderer" },
  { icon: Music2, label: "Scenes", value: "Ring, terrain, wave, and tunnel modes" },
  { icon: ShieldCheck, label: "Control", value: "Local app with no cloud audio path" },
] as const;

export function ToolsDownload() {
  return (
    <main className="tools-shell" aria-labelledby="tools-title">
      <header className="tools-header">
        <a className="tools-brand-link" href="/" aria-label="Miles Systems home">
          <ArrowLeft aria-hidden="true" size={18} />
          <img src="/TruncatedIcosahedron.svg" alt="" />
          <span>Miles Systems</span>
        </a>
        <span className="tools-release-pill">macOS preview 0.1.1</span>
      </header>

      <section className="tools-hero">
        <div className="tools-hero-copy">
          <p className="tools-kicker">Performance Tools</p>
          <h1 id="tools-title">Downloads for live visual systems.</h1>
          <p>
            The web visualizer has been retired. The live performance work is moving into installable tools built for
            DJs, producers, and stage screens.
          </p>
        </div>
        <a className="tools-primary-download" href={macDownloadHref} download>
          <Download aria-hidden="true" size={20} />
          Download macOS build
        </a>
      </section>

      <section className="tools-grid" aria-label="Available tools">
        <article className="tools-card tools-card--featured">
          <div className="tools-card-heading">
            <span className="tools-card-icon" aria-hidden="true">
              <Package size={24} />
            </span>
            <div>
              <p>Preview Build</p>
              <h2>Live Visualizer for macOS</h2>
            </div>
          </div>
          <p>
            A standalone desktop renderer that listens to a Mac audio input and drives fullscreen visual scenes without
            putting the show inside a browser tab.
          </p>
          <div className="tools-capability-grid">
            {capabilities.map(({ icon: Icon, label, value }) => (
              <div className="tools-capability" key={label}>
                <Icon aria-hidden="true" size={18} />
                <span>{label}</span>
                <strong>{value}</strong>
              </div>
            ))}
          </div>
        </article>

        <aside className="tools-card tools-card--compact" aria-label="Build channels">
          <h2>Build Channel</h2>
          <dl className="tools-build-list">
            <div>
              <dt>Latest download</dt>
              <dd>{macDownloadLabel}</dd>
            </div>
            <div>
              <dt>Platform</dt>
              <dd>macOS desktop app</dd>
            </div>
            <div>
              <dt>Packaging</dt>
              <dd>Ad-hoc signed preview zip</dd>
            </div>
            <div>
              <dt>First launch</dt>
              <dd>Control-click Open until Developer ID notarization is in place</dd>
            </div>
          </dl>
          <a className="tools-secondary-link" href={macDownloadHref} download>
            <Download aria-hidden="true" size={17} />
            Download archive
          </a>
        </aside>
      </section>
    </main>
  );
}
